import type React from "react";
import { useState } from "react";

import { FormattedMessage } from "react-intl";

import { useIpadToTvMultiScreenEventsListener } from "services/hooks/useMultiScreenEventListener";
import { PlayerEvent } from "shared-types/player-event";

import { StyledTVMessage } from "./TVMessage.style";
import { withBamLayoutSelector } from "@redux/user/selectors";
import { useSelector } from "react-redux";
import {
	Slide,
	type SlideProps,
	Snackbar,
	SnackbarContent,
	Stack,
} from "@mui/material";
import { ReactComponent as HeyLogo } from "assets/hey.svg";
import { ReactComponent as CheeseLogo } from "assets/cheese.svg";

function SlideTransition(props: SlideProps) {
	return <Slide {...props} direction="right" />;
}

export const TVMessage: React.FC = () => {
	const withBamLayout = useSelector(withBamLayoutSelector);
	const [message, setMessage] = useState<string | null>(null);
	const [MessageLogo, setMessageLogo] =
		useState<React.FC<React.SVGProps<SVGSVGElement>>>(HeyLogo);

	useIpadToTvMultiScreenEventsListener({
		[PlayerEvent.SHOW_LAST_SONG_TV_MESSAGE]: () => {
			setMessageLogo(HeyLogo);
			setMessage("song.last-song-preparation");
		},
		[PlayerEvent.SHOW_LAST_30_MINUTES_TV_MESSAGE]: () => {
			setMessageLogo(HeyLogo);
			setMessage(
				withBamLayout ? "song.last-30-minutes" : "song.last-30-minutes-tsl",
			);
		},
		[PlayerEvent.SHOW_LAST_20_MINUTES_TV_MESSAGE]: () => {
			setMessageLogo(HeyLogo);
			setMessage(
				withBamLayout ? "song.last-20-minutes" : "song.last-20-minutes-tsl",
			);
		},
		[PlayerEvent.SHOW_LAST_10_MINUTES_TV_MESSAGE]: () => {
			setMessageLogo(HeyLogo);
			setMessage(
				withBamLayout ? "song.last-10-minutes" : "song.last-10-minutes-tsl",
			);
		},
		[PlayerEvent.SHOW_VIDEO_TV_MESSAGE]: () => {
			setMessageLogo(CheeseLogo);
			setMessage(withBamLayout ? "flash-messages.video" : null);
		},
		[PlayerEvent.CLEAR_TV_MESSAGE]: () => {
			setMessage(null);
		},
	});

	if (!message) {
		return null;
	}

	return withBamLayout ? (
		<Snackbar
			open={Boolean(message)}
			anchorOrigin={{ vertical: "top", horizontal: "left" }}
			TransitionComponent={SlideTransition}
			sx={{
				maxWidth: "50%",
				backgroundColor: "white",
				borderRadius: "10px",
			}}
		>
			<SnackbarContent
				style={{
					color: "black",
					fontSize: "35px",
					borderRadius: "10px",
					backgroundColor: "white",
				}}
				message={
					<Stack
						direction="row"
						justifyContent="center"
						alignItems="center"
						gap={2}
					>
						<MessageLogo style={{ width: "180px" }} />
						<FormattedMessage id={message} />
					</Stack>
				}
			/>
		</Snackbar>
	) : (
		<StyledTVMessage>
			<FormattedMessage id={message} />
		</StyledTVMessage>
	);
};
